import { render, staticRenderFns } from "./SuperTableDetails.vue?vue&type=template&id=22e69117"
import script from "./SuperTableDetails.vue?vue&type=script&lang=js"
export * from "./SuperTableDetails.vue?vue&type=script&lang=js"
import style0 from "./SuperTableDetails.vue?vue&type=style&index=0&id=22e69117&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports